export enum Globals {
  NAME = 'The Fridge',
  NAME_DEV = 'The Fridge Dev',
}
